export const filterOptions = (options) => options.filter(option => option.poll_option_id !== null)
export const getVotes = (options) => options.map(option => option.votes)
export const getSelections = (options) => options.map(option => option.selection)

export const validateEmail = (email) => {
  const validRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
  return validRegex.test(email)
}

export const uuid = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}



// WEBPACK FOOTER //
// ./src/containers/time-poll/services/poll_helpers.js